import React from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { ButtonContainer } from '../../form';
import { IConfirmationModalProps } from '../types';
import styles from '../Modals.module.css';

export const ConfirmationModal: React.FC<IConfirmationModalProps> = ({
  title,
  message,
  icon,
  kind,
  onConfirmed,
  onRequestClose,
}) => (
  <Modal isOpen className="model-content" overlayClassName="modal-overlay">
    <span className={styles.title}>{title}</span>
    <FontAwesomeIcon
      className={`${styles.icon} text-${kind}`}
      icon={icon}
      size="4x"
    />
    <p>{message}</p>
    <ButtonContainer align="center">
      <Button variant="secondary" onClick={onRequestClose}>
        No
      </Button>
      <Button
        variant={kind === 'danger' ? 'danger' : 'primary'}
        onClick={onConfirmed}
      >
        Yes
      </Button>
    </ButtonContainer>
  </Modal>
);
